import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { SharedTranslatePipe } from '@inside-hub-app/customer-portal-shared'
import { MatIcon } from '@angular/material/icon'
import { MatDivider } from '@angular/material/list'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'

export type cptMenuType = 'editDeleteMenu' | 'fileMenu'

export type cptMenuAction = 'download' | 'edit' | 'delete'

@Component({
  selector: 'customer-portal-app-cpt-menu',
  standalone: true,
  imports: [
    MatIcon,
    MatMenuTrigger,
    MatMenu,
    MatDivider,
    SharedTranslatePipe,
    MatMenuItem,
    HubChildTranslateModule
  ],
  templateUrl: './cpt-menu.component.html'
})
export class CptMenuComponent {
  @Input() menuType: cptMenuType
  @Output() actionClicked = new EventEmitter()

  onActionClicked(action: string): void {
    this.actionClicked.emit(action)
  }
}
